import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Drawer,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";

interface LocationSetupDrawerProps {
  open: boolean;
  onCancel: () => void;
  children: React.ReactNode;
}

const LocationSetupDrawer: React.FC<LocationSetupDrawerProps> = ({
  open,
  onCancel,
  children,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onCancel}
      PaperProps={{
        sx: {
          width: fullScreen ? "100%" : 440,
          maxWidth: "100%",
          bgcolor: "background.default",
          backgroundImage: "none",
        },
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          px: 2.5,
          py: 2,
          borderBottom: "1px solid",
          borderColor: "divider",
          position: "sticky",
          top: 0,
          bgcolor: "background.default",
          zIndex: 2,
        }}
      >
        <Box>
          <Typography variant="h6">{t("dashboard.drawer.title")}</Typography>
          <Typography variant="caption" color="text.secondary">
            {t("dashboard.drawer.subtitle")}
          </Typography>
        </Box>
        <IconButton aria-label={t("dashboard.drawer.cancel")} onClick={onCancel}>
          <CloseIcon />
        </IconButton>
      </Stack>
      <Box sx={{ p: 2.5, overflowY: "auto" }}>{children}</Box>
    </Drawer>
  );
};

export default LocationSetupDrawer;
